import * as React from 'react';
import { useSelector } from 'react-redux';
import { FeatureHeaderProps } from './typings';
import ContextMenu from '../components/contextMenu/ContextMenu';
import { CommonRootState } from '../store/typings';
import { printWithoutFeatureHeader } from '../util/shared/sharedUtils';

const FeatureHeader = React.memo((props: FeatureHeaderProps) => {
    const {
        featureId, title, showHeader, withHeader, headerMode, featureContextMenu,
        featureName, promotedActions, appStore, featureNamespace, hideContextMenu, actionStatusService,
        contextMenuAlwaysActive, contextMenuAboveFeature,
    } = props;
    const globalState: CommonRootState = useSelector((state: CommonRootState) => state);
    const featureState = globalState[props.featureId];
    const printMode = globalState.workspaces.printMode;

    const hasPermissionForAction = actionStatusService.hasPermissionForAction;
    const shouldShowFeatureHeader = showHeader && withHeader && !printWithoutFeatureHeader();
    const shouldShowContextMenu = !headerMode && featureState && !hideContextMenu && !printMode;
    const contextMenu = (
        <ContextMenu
            featureState={featureState}
            featureContextMenu={featureContextMenu}
            featureName={featureName}
            withHeader={withHeader}
            featureId={featureId}
            promotedActions={promotedActions}
            appStore={appStore}
            featureNamespace={featureNamespace}
            actionStatusService={actionStatusService}
            hasPermissionForAction={hasPermissionForAction}
            disableTabNameEditWhenNotExpanded={(dataType: string) => dataType === 'USERQUESTION'}
        />
    );

    const renderFeatureHeader = () => {
        const alwaysActiveClass = contextMenuAlwaysActive ? ' contextMenuAlwaysActive' : '';
        const studentReportFeatureHeaderClass = featureName === 'studentReport' ? ' studentReportFeatureHeader' : '';

        if (shouldShowFeatureHeader && shouldShowContextMenu) {
            return (
                <div className={`featureHeader flexSpaceBetween${studentReportFeatureHeaderClass}`}>
                    <h2>{title}</h2>
                    {contextMenu}
                </div>
            );
        }

        if (shouldShowFeatureHeader && !shouldShowContextMenu) {
            return (
                <div className="featureHeader flexStart">
                    <h4>{title}</h4>
                </div>
            );
        }

        if (!shouldShowFeatureHeader && shouldShowContextMenu) {
            return (
                <div className={`${contextMenuAboveFeature ? 'featureHeader flexEnd' : 'contextMenuNotInFeatureHeader'}${alwaysActiveClass}`}>
                    {contextMenu}
                </div>
            );
        }

        return null;
    };

    return renderFeatureHeader();
});

export default FeatureHeader;
